export default defineNuxtRouteMiddleware(() => {
  const transitionStore = usePageTransitionStore()

  if (!transitionStore.isTransitioning) {
    return
  }

  return new Promise<void>((resolve) => {
    const stopWatching = transitionStore.$subscribe((_, state) => {
      if (!state.isTransitioning) {
        stopWatching()
        resolve()
      }
    })
  })
})
